var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { registerDecorator } from 'class-validator';
import { z } from 'zod';
// https://regex101.com/r/U2o2dW/1
var symbolRegex = /[^A-Za-z0-9 ]/gi;
// https://regex101.com/r/u88IfK/1
var numberRegex = /[0-9]/gi;
// TODO: we really should just enourage creating memorable passwords
// with a minimum length of 12-20 characters, and not require symbols or numbers
// https://www.wired.com/2016/03/want-safer-passwords-dont-change-often/
// above article is not that good but it does link to this:
// https://www.baekdal.com/thoughts/password-security-usability
// > It is 10 times more secure to use "this is fun" as your password, than "J4fS<2".
export var passwordValidator = z
    .string({
    required_error: 'password is required',
    invalid_type_error: 'password must be a string',
})
    .min(8, { message: 'password must be at least 8 characters' })
    .refine(function (str) { var _a; return Number((_a = str.match(numberRegex)) === null || _a === void 0 ? void 0 : _a.length) >= 1; }, {
    message: 'password must contain at least 1 digit',
})
    .refine(function (str) { var _a; return Number((_a = str.match(symbolRegex)) === null || _a === void 0 ? void 0 : _a.length) >= 1; }, {
    message: 'password must contain at least 1 symbol',
});
export function IsPassword(validationOptions) {
    return function (object, propertyName) {
        var _a;
        registerDecorator({
            name: 'IsPassword',
            target: object.constructor,
            propertyName: propertyName,
            options: __assign(__assign({}, validationOptions), { message: (_a = validationOptions === null || validationOptions === void 0 ? void 0 : validationOptions.message) !== null && _a !== void 0 ? _a : 'Password must be at least 8 characters, contain at least 1 digit, and contain at least 1 symbol' }),
            validator: {
                validate: function (value) {
                    return __awaiter(this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, passwordValidator.parseAsync(value)];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/, true];
                                case 2:
                                    _a = _b.sent();
                                    return [2 /*return*/, false];
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                },
            },
        });
    };
}
//# sourceMappingURL=passwordValidator.js.map